import {Component, Inject, OnInit} from '@angular/core';
import {FeedbackInfo} from '../../models/feedback.model';
import {UserInformationService} from '../../services/user-information.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {SupportRequestModel} from '../../models/support-request.model';
import {atLeastOneRequiredValidator} from '../../validators/atLeastOneRequiredValidator.validator';

interface FeedbackDialogData {
    name: string;
    isCaseForm: boolean;
}

@Component({
    selector: 'vi-feedback-dialog',
    templateUrl: './feedback-dialog.component.html',
    styleUrls: ['./feedback-dialog.component.scss']
})
export class FeedbackDialogComponent implements OnInit {
    feedbackForm!: FormGroup;
    isCaseForm!: boolean;

    constructor(
        public dialogRef: MatDialogRef<FeedbackDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: FeedbackDialogData,
        public userInformationService: UserInformationService,
        private formBuilder: FormBuilder
    ) {}

    ngOnInit(): void {
        this.isCaseForm = this.data.isCaseForm;
        this.feedbackForm = this.buildForm();
        this.prefillUserData();
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    getFeedbackData(): void {
        this.feedbackForm.markAllAsTouched();
        if (!this.feedbackForm.valid) {
            return;
        }
        const result = this.isCaseForm ? this.buildSupportRequest() : this.buildFeedbackInfo();
        this.dialogRef.close(result);
    }

    private buildForm(): FormGroup {
        return this.formBuilder.group({
            mailFrom: ['', Validators.required],
            mailSubject: ['', Validators.required],
            mailSystemOrComponent: ['', this.isCaseForm ? [] : [Validators.required]],
            caseSystem: [''],
            caseSerial: [''],
            mailBody: ['', [Validators.required, Validators.minLength(40)]],
        }, {
            validators: this.isCaseForm ? atLeastOneRequiredValidator('caseSystem', 'caseSerial') : null
        });
    }

    private prefillUserData(): void {
        if (!this.userInformationService.loggedIn) {
            return;
        }
        this.getValue('mailFrom').setValue(this.userInformationService.user.contacts.email);
        if (this.userInformationService.shownEquipment) {
            this.getValue('mailSystemOrComponent').setValue(this.userInformationService.shownEquipment);
            this.getValue('caseSystem').setValue(this.userInformationService.shownEquipment);
        }
    }

    private buildFeedbackInfo(): FeedbackInfo {
        const fb = new FeedbackInfo();
        fb.mailBody = this.getValue('mailBody').value;
        fb.mailFrom = this.getValue('mailFrom').value;
        fb.mailSubject = this.getValue('mailSubject').value;
        fb.mailSystemOrComponent = this.getValue('mailSystemOrComponent').value;
        return fb;
    }

    private buildSupportRequest(): SupportRequestModel {
        const body = this.getValue('mailBody').value;
        return {
            userText: body,
            text: body,
            requestor: this.getValue('mailFrom').value,
            subject: this.getValue('mailSubject').value,
            systemId: this.getValue('caseSystem').value,
            serialNumber: this.getValue('caseSerial').value,
            source: 'OVERVIEW'
        };
    }

    private getValue(field: string) {
        return this.feedbackForm.get(field)!;
    }
}
